export default "__VITE_ASSET__CwFjOcce__"